
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Fiftythreebharat() {



    const cardData =
    {
        keyword: '53 Seater Bharat Benz Bus On Rent in Pune',
        heading: 'Amruta Travels: 53 Seater Bharat Benz Bus On Rent in Pune',
        headingDescription: 'Amruta Travels offers 53 Seater BharatBenz Bus on Rent in Pune, ideal for transporting large groups with comfort, safety, and efficiency. Whether it is a corporate event, wedding, school excursion, or religious tour, our spacious BharatBenz buses provide smooth rides with ample seating, air-conditioning, and luggage space. Known for their reliability and performance, these buses are operated by skilled drivers ensuring punctual and secure travel. With 24/7 customer support and competitive rental rates, Amruta Travels is your go-to choice for dependable bus hire services in Pune.',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',


  "topPlaces": [
    {
      "title": "Mahabaleshwar",
      "description": "Located around 120 km from Pune, Mahabaleshwar is a picturesque hill station in the Western Ghats, known for its cool climate, evergreen forests, and stunning viewpoints such as Arthur’s Seat, Wilson Point (the highest point), and Kate's Point. The region is famous for its strawberry farms, especially during the Strawberry Festival held in spring. Other attractions include Venna Lake for boating, Mapro Garden for strawberry-based treats, and ancient temples like Panchganga and Mahabaleshwar Temple. It's a popular destination for families, honeymooners, and nature enthusiasts seeking a refreshing escape from city life."
    },
    {
      "title": "Lonavala & Khandala",
      "description": "Just 66 km from Pune, these twin hill stations in the Sahyadri range offer a perfect blend of natural beauty and adventure. Lonavala is known for its misty mountains, lush greenery, and monsoon waterfalls like Kune and Bhivpuri. Attractions include Bhushi Dam, Tiger’s Leap, Rajmachi Fort, and Karla & Bhaja Caves. Khandala is equally famous for its panoramic valley views and trekking routes. The area is ideal for a weekend drive, with scenic routes and roadside chikki stalls that add to the charm of this quick getaway."
    },
    {
      "title": "Shirdi",
      "description": "About 190 km from Pune, Shirdi is a sacred town revered by followers of Sai Baba. The Sai Baba Samadhi Mandir is the main attraction, drawing millions of devotees every year. Pilgrims can also visit Dwarkamai, Chavadi, and the Sai Heritage Village. The spiritual ambiance, combined with well-maintained infrastructure and religious events, makes Shirdi a prominent destination for those seeking peace, healing, and spiritual growth."
    },
    {
      "title": "Goa",
      "description": "Located nearly 450 km from Pune, Goa is India’s premier beach destination, known for its lively culture, golden beaches, and Portuguese heritage. From North Goa’s party hotspots like Baga, Anjuna, and Calangute to South Goa’s serene stretches like Palolem and Colva, there’s a vibe for every traveler. Apart from beaches, visitors can explore Aguada Fort, Basilica of Bom Jesus, spice plantations, vibrant flea markets, and indulge in thrilling water sports. Goa is also a haven for foodies, offering authentic seafood, Goan curries, and beachside shacks serving refreshing cocktails."
    },
    {
      "title": "Nashik",
      "description": "Around 210 km from Pune, Nashik is a city of immense cultural, historical, and spiritual significance. It is one of the four cities where the Kumbh Mela is held. Attractions include the ancient Kalaram Temple, Muktidham Temple, Pandavleni Caves, and Trimbakeshwar Temple—an important Jyotirlinga. Nashik is also the wine capital of India, home to Sula Vineyards, York Winery, and many tasting tours. The Godavari River adds to its charm, making it a harmonious blend of spirituality and leisure tourism."
    },
    {
      "title": "Alibaug",
      "description": "Situated about 140 km from Pune, Alibaug is a tranquil coastal town offering a perfect mix of beaches, history, and nature. Popular beaches include Nagaon, Alibaug Beach, and Kashid Beach, all great for swimming, sunbathing, and water sports. The iconic Kolaba Fort, accessible during low tide, adds historical value to the destination. You can also explore Korlai Fort, Kanakeshwar Temple, and local seafood cuisine. Ideal for weekend trips, Alibaug also offers ferry services from Mumbai for added convenience."
    },
    {
      "title": "Kolhapur",
      "description": "Roughly 235 km from Pune, Kolhapur is a vibrant city known for its divine Mahalaxmi Temple, which draws pilgrims throughout the year. The city is equally famous for its spicy cuisine, Kolhapuri chappals, and traditional arts. Attractions include Rankala Lake for evening strolls, Panhala Fort offering panoramic views, and the New Palace Museum showcasing royal heritage. With its rich cultural identity and warm hospitality, Kolhapur is ideal for heritage and culinary tourism."
    },
    {
      "title": "Lavasa",
      "description": "Just 60 km from Pune, Lavasa is an Italian-inspired planned city nestled in the Sahyadri hills. It features beautiful waterfronts, European-style architecture, and a peaceful atmosphere perfect for a quick weekend escape. Activities include kayaking, zip-lining, and lakeside cycling. With cozy resorts, conference centers, and nature trails, Lavasa attracts both families and corporate travelers. The weather remains pleasant most of the year, enhancing its appeal as a rejuvenating destination close to Pune."
    },
    {
      "title": "Satara & Kaas Plateau",
      "description": "About 120 km from Pune, Satara serves as the base for exploring the Kaas Plateau—popularly known as the 'Valley of Flowers' of Maharashtra. The plateau, a UNESCO World Natural Heritage site, bursts into a riot of colors with over 850 species of wildflowers during the monsoon season. Satara is also known for Ajinkyatara Fort, Thoseghar Waterfalls, and Sajjangad Fort. The natural beauty and biodiversity make this region a paradise for trekkers, botanists, and photographers."
    },
    {
      "title": "Aurangabad",
      "description": "Situated 235 km from Pune, Aurangabad is a historical treasure trove, offering insights into ancient art, architecture, and culture. The city is home to the world-famous Ajanta and Ellora Caves, adorned with exquisite carvings and paintings dating back to 2nd century BCE. Other attractions include Bibi Ka Maqbara (a replica of the Taj Mahal), Daulatabad Fort, and Aurangabad Caves. The city is also a gateway to Grishneshwar Jyotirlinga and Paithani saree shopping, making it a must-visit for heritage lovers."
    }
  ],

    "services": [
    {
      "name": "Bharat Benz 53 Seater Bus on Rent in Pune",
      "description": "Rent a 53 Seater Bharat Benz bus in Pune for group travel, events, and long-distance trips. Our buses are equipped with air conditioning, comfortable seating, and modern amenities, ensuring a premium travel experience for all passengers."
    },
    {
      "name": "53 Seater AC Bharat Benz Bus Hire Pune",
      "description": "Book a 53 Seater AC Bharat Benz bus for your next trip from Pune. Ideal for corporate events, family outings, and weddings, these buses provide ultimate comfort with air conditioning, reclining seats, and ample space for a luxurious journey."
    },
    {
      "name": "Corporate Bus Rental Bharat Benz Pune",
      "description": "Looking for corporate transport in Pune? Our 53 Seater Bharat Benz buses are perfect for corporate events, meetings, conferences, and team outings. With luxury seating and air conditioning, your team will travel in style and comfort."
    },
    {
      "name": "Bharat Benz Wedding Bus Hire 53 Seater",
      "description": "Make your wedding day even more special by hiring our 53 Seater Bharat Benz bus. Offering luxury seating and a comfortable ride, our buses are perfect for transporting guests to and from the wedding venue, ensuring they arrive in style."
    },
    {
      "name": "School Picnic Bus 53 Seater Pune",
      "description": "Planning a school picnic? Our 53 Seater Bharat Benz buses are a great option for school trips. Equipped with air conditioning and spacious seating, these buses provide a safe and comfortable journey for students and teachers."
    },
    {
      "name": "Bharat Benz 53 Seater Bus for Outstation Trips",
      "description": "Travel to outstation destinations in style with our 53 Seater Bharat Benz buses. Whether it’s for a family vacation or a corporate retreat, our buses offer premium comfort and safety for long-distance journeys."
    },
    {
      "name": "Bharat Benz Bus Hire for Events Pune",
      "description": "For any event in Pune, our 53 Seater Bharat Benz buses offer the perfect transport solution. Whether it’s a conference, exhibition, or team-building event, our buses provide luxury travel for your guests and attendees."
    },
    {
      "name": "Pune to Shirdi 53 Seater Bus Bharat Benz",
      "description": "Embark on a spiritual journey with our 53 Seater Bharat Benz bus to Shirdi. Offering comfortable seating, air conditioning, and a reliable driver, our buses ensure a smooth and peaceful trip to this sacred destination."
    },
    {
      "name": "53 Seater Bharat Benz in Kharadi Pune",
      "description": "Rent a 53 Seater Bharat Benz bus in Kharadi for your group travel needs. Perfect for corporate events, weddings, or school trips, our buses provide the luxury and comfort needed for both short and long trips."
    },
    {
      "name": "53 Seater Bharat Benz Bus for Conference",
      "description": "Our 53 Seater Bharat Benz buses are an excellent choice for conference transportation. With luxury seating, air conditioning, and ample space for passengers, these buses are perfect for transporting attendees to and from conference venues in comfort."
    },
    {
      "name": "Bharat Benz 53 Seater Bus Hire in Hadapsar",
      "description": "If you're in Hadapsar and need transport for a large group, our 53 Seater Bharat Benz buses offer the perfect solution. Whether it’s for corporate events, family functions, or religious tours, enjoy a luxurious ride with all the modern amenities."
    },
    {
      "name": "Bharat Benz Bus Rental in PCMC 53 Seater",
      "description": "Rent a 53 Seater Bharat Benz bus in PCMC for your next event or outing. Our buses offer comfort, luxury, and reliable service for weddings, conferences, and group tours, ensuring a seamless travel experience."
    },
    {
      "name": "Pune to Mahabaleshwar Bus Hire 53 Seater",
      "description": "Take a trip to Mahabaleshwar with our 53 Seater Bharat Benz bus. Whether it's a family tour or corporate getaway, our buses provide a comfortable and luxurious travel experience, making your journey to this hill station enjoyable."
    },
    {
      "name": "Bharat Benz Luxury Coach 53 Seater Pune",
      "description": "Travel in luxury with our 53 Seater Bharat Benz luxury coach. Perfect for group tours, weddings, and corporate events, our buses provide a premium experience with features like air conditioning, reclining seats, and spacious interiors."
    },
    {
      "name": "Event Transport 53 Seater Bus Rental",
      "description": "For your next event, our 53 Seater Bharat Benz buses are the perfect transport solution. From weddings and conferences to team-building events and exhibitions, our buses offer comfort, style, and ample space for all your guests."
    }
  ],
  "tableData": [
    ["Bharat Benz 53 Seater Bus on Rent in Pune", "53 Seater AC Bharat Benz Bus Hire Pune"],
    ["Corporate Bus Rental Bharat Benz Pune", "Bharat Benz Wedding Bus Hire 53 Seater"],
    ["School Picnic Bus 53 Seater Pune", "Bharat Benz 53 Seater Bus for Outstation Trips"],
    ["Bharat Benz Bus Hire for Events Pune", "Pune to Shirdi 53 Seater Bus Bharat Benz"],
    ["53 Seater Bharat Benz in Kharadi Pune", "53 Seater Bharat Benz Bus for Conference"],
    ["Bharat Benz 53 Seater Bus Hire in Hadapsar", "Bharat Benz Bus Rental in PCMC 53 Seater"],
    ["Pune to Mahabaleshwar Bus Hire 53 Seater", "Bharat Benz Luxury Coach 53 Seater Pune"],
    ["Event Transport 53 Seater Bus Rental"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "53 Seater Bharat Benz Bus on Rent in Pune",
    "WhyChoosedescription": "Amruta Travels offers the high-quality 53 Seater Bharat Benz buses on rent in Pune, perfect for large group travel. Whether it's for a corporate trip, family event, or a school tour, our Bharat Benz buses combine luxury and comfort to ensure a superior travel experience."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Air-Conditioned Travel",
    "WhyChoosedescription": "Our 53 Seater Bharat Benz buses are equipped with powerful air-conditioning, plush reclining seats, and ample legroom, ensuring your group enjoys a comfortable and relaxed journey, whether you're traveling short or long distances."
  },
  {
    "WhyChooseheading": "Premium Amenities for a Luxurious Experience",
    "WhyChoosedescription": "These buses feature top-tier amenities, including well-cushioned seats, wide windows for scenic views, onboard entertainment options, and modern air-conditioning systems, making every journey an enjoyable and luxurious experience for all passengers."
  },
  {
    "WhyChooseheading": "Affordable, Transparent, and Inclusive Pricing",
    "WhyChoosedescription": "At Amruta Travels, we offer transparent pricing for 53 Seater Bharat Benz bus rentals. Our all-inclusive rates cover fuel, tolls, driver charges, taxes, and more, ensuring there are no hidden costs and helping you plan your trip budget with ease."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Safe and Punctual Travel",
    "WhyChoosedescription": "Our drivers are highly experienced, licensed, and knowledgeable about Pune’s routes and major outstation destinations. They prioritize your safety and comfort while maintaining punctuality and delivering professional service throughout your journey."
  },
  {
    "WhyChooseheading": "Perfect for Large Group Outings, Corporate Events, and Tours",
    "WhyChoosedescription": "The 53 Seater Bharat Benz bus is ideal for large group events like corporate outings, family reunions, educational trips, or destination weddings. Its combination of space, luxury, and reliability makes it the perfect travel choice for any large group occasion."
  },
  {
    "WhyChooseheading": "Well-Maintained Fleet for a Safe and Smooth Ride",
    "WhyChoosedescription": "Our fleet of 53 Seater Bharat Benz buses undergoes regular inspections and maintenance to ensure optimal performance. We take pride in providing well-maintained vehicles that guarantee a smooth, safe, and worry-free journey."
  },
  {
    "WhyChooseheading": "Convenient Booking and 24/7 Customer Support",
    "WhyChoosedescription": "Booking your 53 Seater Bharat Benz bus with Amruta Travels is easy and hassle-free. You can reserve your bus online, by phone, or at our office. Our 24/7 customer support team is always available to assist with bookings, special requests, and any travel-related inquiries."
  }
]



















    }

const faqData = [
  {
    question: 'Can I rent a 53-seater Bharat Benz bus in Pune with Amruta Travels?',
    answer: 'Yes, Amruta Travels offers 53-seater Bharat Benz buses for rent in Pune. These buses are ideal for large groups and are perfect for corporate events, family outings, school tours, and long-distance travel.',
  },
  {
    question: 'What amenities are available in the 53-seater Bharat Benz bus?',
    answer: 'Our 53-seater Bharat Benz buses are equipped with premium amenities such as comfortable seating, air conditioning, modern entertainment systems, spacious luggage compartments, overhead storage, and clean, well-maintained interiors.',
  },
  {
    question: 'Is the 53-seater Bharat Benz bus available for both local and outstation travel?',
    answer: 'Yes, the 53-seater Bharat Benz bus is available for local city travel in Pune as well as outstation trips to popular destinations like Lonavala, Mahabaleshwar, Shirdi, Mumbai, and other tourist spots.',
  },
  {
    question: 'Is a driver included in the 53-seater Bharat Benz bus rental?',
    answer: 'Yes, all 53-seater Bharat Benz bus rentals from Amruta Travels come with an experienced, professional, and licensed driver who ensures safe, comfortable, and timely travel for all passengers.',
  },
  {
    question: 'How much does it cost to rent a 53-seater Bharat Benz bus in Pune?',
    answer: 'Rental charges for the 53-seater Bharat Benz bus depend on factors like distance, trip duration, and additional services. Typically, rates start from ₹75-₹90 per km. Please contact us for a customized quote based on your travel details.',
  },
  {
    question: 'Is the 53-seater Bharat Benz bus comfortable for long journeys?',
    answer: 'Yes, the 53-seater Bharat Benz bus is designed for long journeys, offering spacious seating, air conditioning, and ample legroom for a comfortable and relaxing experience on extended trips.',
  },
  {
    question: 'Are the 53-seater Bharat Benz buses well-maintained and sanitized?',
    answer: 'Absolutely. All our 53-seater Bharat Benz buses are regularly serviced, thoroughly cleaned, and sanitized before every trip to ensure the highest standards of hygiene, safety, and passenger comfort.',
  },
  {
    question: 'How do I book a 53-seater Bharat Benz bus in Pune?',
    answer: 'Booking a 53-seater Bharat Benz bus is simple! You can easily book online through our website or by contacting our customer support team. We offer fast booking and transparent pricing.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Arun Deshmukh',
    role: 'Event Coordinator, Pune',
    text: 'We hired a 53-seater Bharat Benz bus from Amruta Travels for a corporate event. The bus was very spacious, comfortable, and the air conditioning kept everyone cool during the journey. The service was top-notch!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Radhika Sharma',
    role: 'Tour Planner',
    text: 'I booked a 53-seater Bharat Benz bus for a group of tourists traveling to Mahabaleshwar. The bus was in excellent condition, and the passengers enjoyed a comfortable and pleasant trip. Highly recommend Amruta Travels!',
    rating: 5,
  },
];




























































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "53 Seater Bharat Benz Bus On Rent in Pune",
  "image": "https://bushireinpune.com/assets/images/53-seater-bharat-benz-bus.jpg",
  "description": "Book a 53 Seater Bharat Benz Bus on Rent in Pune with Amruta Travels for weddings, corporate events, school picnics, conferences, and outstation trips to Shirdi or Mahabaleshwar. Our air-conditioned Bharat Benz coaches offer premium comfort for large groups in areas like Kharadi, Hadapsar, and PCMC.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "12650"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7900",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/53-seater-bharat-benz-bus-rent-pune"
  }
};






    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | 53 Seater Bharat Benz Bus On Rent in Pune | AC Coach for Weddings & Corporate Travel</title>
  <meta 
    name="description" 
    content="Hire a 53 seater AC Bharat Benz bus in Pune for weddings, corporate events, school tours, and outstation trips like Pune to Shirdi or Mahabaleshwar. Premium group transport by Amruta Travels." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/86.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Fiftythreebharat;